export enum Web2AppLinkType {
  PERSONALIZED = 'personalized',
  FALLBACK = 'fallback',
}
